import Menu from "./modules/menu";
import Theme from "./modules/theme";
import ToTop from "./modules/toTop";
import ShowMore from "./modules/showMore";
import ShowMoreGallery from "./modules/showMoreGallery";

Menu.init();
Theme.init();
ToTop.init();
ShowMore.init();
ShowMoreGallery.init();